import { Flex, Heading, HStack, Stack, Text } from "@chakra-ui/layout";
import { Trans } from "@lingui/macro";
import { DataTable } from "@src/components/ui-kit";
import { ProgressBar } from "@src/components/ui-kit/NewProgressBar";
import {
  currency,
  HUNDRED_PERCENT,
  percent as percentFormatter,
} from "@src/utils/formatters";
import { observer } from "mobx-react-lite";

type UserProfitPerMonthStatCardProps = {
  profit: number | undefined | null;
  revenue: number | undefined | null;
};
export const UserProfitPerMonthStatCard = observer(
  function UserProfitPerMonthStatCard({
    profit,
    revenue,
  }: UserProfitPerMonthStatCardProps) {
    const percent = !profit
      ? 0
      : ((profit ?? 0) / (revenue ?? 1)) * HUNDRED_PERCENT;

    return (
      <DataTable.StatCard>
        <Stack>
          <HStack justify="space-between" mb="2">
            <Heading size="sm">
              <Trans>User profit</Trans>
            </Heading>
            <Heading size="sm">{percentFormatter.format(percent)}</Heading>
          </HStack>
          <ProgressBar
            segments={[
              {
                percent,
                bg: "teal.500",
              },
            ]}
          />
          <Flex fontSize="sm">
            <Text color="grey.600">
              <Trans>Profit</Trans>
            </Text>
            &nbsp;
            <Text fontWeight="medium">
              {currency.formatByWorkspace(profit ?? 0)}
            </Text>
          </Flex>
        </Stack>
      </DataTable.StatCard>
    );
  },
);
